import React, { Component } from 'react'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import { History } from 'history'

import { parseQueryForDisplay, stringifyQuery } from '../../helpers/queryHelper'

import RefiTransactionsFilterForm from './refiTransactionsFilterForm'

export type Callback<T = void> = (...args: any) => T

export interface Props {
  change: Callback
  history: History
  location: Location
}

export class RefiTransactionsFilter extends Component<Props> {
  onSubmit = (values) => {
    const { history } = this.props
    const withDefaults = Object.assign({}, values, {
      offset: 0,
      limit: 25,
    })
    history.push({
      pathname: '/refinance',
      search: stringifyQuery(withDefaults),
    })
  }

  cancel = () => {
    const {
      history,
      location: { search },
    } = this.props

    history.push({
      pathname: '/refinance',
      search,
    })
  }

  destroy = () => {
    const {
      change,
      history,
      location: { search },
    } = this.props
    const valueArray = Object.keys(parseQueryForDisplay(search))
    valueArray.forEach((value) => {
      change('refiTransactionsFilterForm', value, null)
    })
    history.push({
      pathname: '/refinance',
    })
  }

  initialValues = () => {
    const { location } = this.props
    return parseQueryForDisplay(location.search)
  }

  render() {
    return (
      <div className="index-filter">
        <h1 className="index-filter__header">Refinance Filters</h1>
        <RefiTransactionsFilterForm
          onSubmit={this.onSubmit}
          initialValues={this.initialValues()}
          cancel={this.cancel}
          clear={this.destroy}
        />
      </div>
    )
  }
}

export default connect(null, {
  change,
})(RefiTransactionsFilter)
